import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeIcon from '@mui/icons-material/Home';
import CalculateIcon from '@mui/icons-material/Calculate';

const cards = [
  {
    title: 'Find a Loan Officer',
    icon: <LocationOnIcon sx={{ fontSize: 50, color: '#b89b5e' }} />,
    path: '/find-a-loan-officer',
  },
  {
    title: 'Mortgage Calculators',
    icon: <CalculateIcon sx={{ fontSize: 50, color: '#b89b5e' }} />,
    path: '/calculators',
  },
  {
    title: 'Loan Programs',
    icon: <HomeIcon sx={{ fontSize: 50, color: '#b89b5e' }} />,
    path: '/loan-programs',
  },
  {
    title: 'What to expect',
    icon: <CalculateIcon sx={{ fontSize: 50, color: '#b89b5e' }} />,
    path: '/purchase',
  },
];

const QuickAccessCards = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: '#f9f9f9', py: 5 }}>
      <Typography
        variant="h2"
        align="center"
        sx={{ mb: 4, color: '#333' }}
      >
        Quick Access
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              elevation={3}
              onClick={() => navigate(card.path)}
              sx={{
                textAlign: 'center',
                py: 4,
                px: 2,
                minHeight: 200,
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#f4ecd7',
                  boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent>
                {card.icon}
                <Typography variant="h4" component="h3" sx={{ mt: 2, color: '#b89b5e' }}>
                  {card.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuickAccessCards;
